<app-button-close (click)="cancel()"></app-button-close>

<div [kalLoading]="loading$ | async">

    <h4 class="title">{{title}}</h4>

    <div>

        <kal-tab-group [formGroup]="form" [formControl]="tabControl">

            <!-- Informations -->
            <kal-tab>

                <ng-template kalTabLabel>
                    Informations
                    <kal-icon *ngIf="hasError('informations')"
                              class="--error-notice">
                        brightness_1
                    </kal-icon>
                </ng-template>

                <ng-template kalTabContent>
                    <ng-container *ngTemplateOutlet="informationsTemplateRef; context: {form: form}"></ng-container>
                    <ng-container *ngTemplateOutlet="tabFooter"></ng-container>
                </ng-template>

            </kal-tab>

            <!-- Pour qui -->
            <kal-tab>
                <ng-template kalTabLabel>
                    Pour qui
                    <kal-icon *ngIf="hasRuleError({simpleRuleControlName: 'who', isAdvancedRuleControlName: 'isWhoAdvanced', advancedRuleControlName: 'whoAdvanced'})"
                              class="--error-notice">
                        brightness_1
                    </kal-icon>
                </ng-template>

                <ng-template kalTabContent>
                    <app-shared-allocation-accessibility-edit
                        *ngIf="!isRuleAdvanced(ruleTypeEnum.Accessibilite) else accessibilityAdvancedRuleTemplate"
                        [isNominative]="isNominative"
                        formControlName="who">
                    </app-shared-allocation-accessibility-edit>

                    <ng-template #accessibilityAdvancedRuleTemplate>

                        <app-shared-advanced-rule formControlName="whoAdvanced"
                                                  [ruleId]="advancedRuleId(ruleTypeEnum.Accessibilite)"
                                                  [ruleType]="ruleTypeEnum.Accessibilite"
                                                  [activityType]="activityType"
                                                  hideInteractivityRulePicker>
                        </app-shared-advanced-rule>

                    </ng-template>

                    <ng-container *ngTemplateOutlet="tabFooter"></ng-container>

                </ng-template>

            </kal-tab>

            <!-- Combien -->
            <kal-tab>
                <ng-template kalTabLabel>
                    Combien
                    <kal-icon *ngIf="hasRuleError({simpleRuleControlName: 'howMuch', isAdvancedRuleControlName: 'isHowMuchAdvanced', advancedRuleControlName: 'howMuchAdvanced'})"
                              class="--error-notice">
                        brightness_1
                    </kal-icon>
                </ng-template>

                <ng-template kalTabContent>
                    <app-shared-allocation-edit-envelope
                        *ngIf="!isRuleAdvanced(ruleTypeEnum.Subvention) else subventionAdvancedRuleTemplate"
                        [type]="type"
                        formControlName="howMuch">
                    </app-shared-allocation-edit-envelope>

                    <ng-template #subventionAdvancedRuleTemplate>

                        <app-shared-advanced-rule formControlName="howMuchAdvanced"
                                                  [ruleId]="advancedRuleId(ruleTypeEnum.Subvention)"
                                                  [ruleType]="ruleTypeEnum.Subvention"
                                                  [activityType]="activityType"
                                                  [allocationType]="type"
                                                  hideInteractivityRulePicker>
                        </app-shared-advanced-rule>

                    </ng-template>

                    <ng-container *ngTemplateOutlet="tabFooter"></ng-container>

                </ng-template>
            </kal-tab>

        </kal-tab-group>

    </div>

</div>


<ng-template #tabFooter>

    <div class="gup-C-validationArea gup-O-list">

        <div class="gup-O-list__item">

            <kal-button (click)="save()"
                        [disabled]="form.invalid"
                        kalTheme="primary">
                Enregistrer
            </kal-button>

        </div>

        <div class="gup-O-list__item">

            <kal-button (click)="cancel()"
                        kalTheme="secondary">
                Annuler
            </kal-button>

        </div>

        <div class="gup-O-list__item"
             *ngIf="tabControl.value > 0">

            <kal-button (click)="switchToAdvancedMode()"
                        [disabled]="!!allocation?.AttribTgExec"
                        kalTheme="tertiary">
                {{ switchToAdvancedModeLabel }}
            </kal-button>

        </div>

    </div>
</ng-template>
